import reducer, { UserState } from './reducers';

import * as userOperations from './operations';

export { userOperations, UserState };

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/user/index.ts